"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { ReactNode, useEffect } from "react";

import { SESSION_RECORDING_CONFIG } from "@/config/sessionRecordingConfig";
import { useSessionTracking } from "@/hooks/useSessionTracking";
import { isLocalhostSync } from "@/utils/trackingFilter";

function PostHogProviderWrapper({ children }: { children: ReactNode }) {
  useSessionTracking();

  return <>{children}</>;
}

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    const skipTracking = isLocalhostSync();

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: "/ph",
      ui_host: "https://us.i.posthog.com",
      defaults: "2026-01-30",
      autocapture: !skipTracking,
      capture_pageview: skipTracking ? false : "history_change",
      capture_dead_clicks: !skipTracking,
      cross_subdomain_cookie: true,
      person_profiles: "identified_only",

      disable_session_recording: skipTracking,
      session_recording: {
        sampleRate: SESSION_RECORDING_CONFIG.sampleRate,
        maskAllInputs: false,
        maskTextSelector: SESSION_RECORDING_CONFIG.maskSelectors.join(", "),
        blockSelector: SESSION_RECORDING_CONFIG.maskSelectors
          .filter((s) => s.includes('type="password"]'))
          .join(", "),
      },

      enable_heatmaps: !skipTracking,
      enable_recording_console_log: !skipTracking,
    });
  }, []);

  return (
    <PHProvider client={posthog}>
      <PostHogProviderWrapper>{children}</PostHogProviderWrapper>
    </PHProvider>
  );
}
